import "bootstrap/dist/css/bootstrap.min.css";
import "./components/style.css";

import { Route, BrowserRouter, Routes } from "react-router-dom";

import {
  Login,
  Cadastro,
  Redefinir,
  Home,
  Form1,
  Form2,
  Form3,
  Form4,
  Form5,
  Aceite,
  Contato,
  Contrato,
  Financeiro,
  Recibo
} from "./pages";

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/redefinir" element={<Redefinir />} />
        <Route path="/home" element={<Home />} />
        <Route path="/form1" element={<Form1 />} />
        <Route path="/form2" element={<Form2 />} />
        <Route path="/form3" element={<Form3 />} />
        <Route path="/form4" element={<Form4 />} />
        <Route path="/form5" element={<Form5 />} />
        <Route path="/aceite" element={<Aceite />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/contrato" element={<Contrato />} />
        <Route path="/financeiro" element={<Financeiro />} />
        <Route path="/recibo" element={<Recibo />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
